import styled, { createGlobalStyle } from "styled-components";

export const Wrapper = styled.div`
  .billing-coupons-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
  }

  .billing-coupons-title {
    font-size: 18px;
    font-weight: 800;
    color: var(--app-text);
    letter-spacing: -0.02em;
  }

  .billing-coupons-subtitle {
    margin-top: 4px;
    font-size: 13px;
    color: var(--app-text-muted);
  }

  .billing-coupons-toolbar {
    background: var(--app-surface);
    border-radius: 12px;
    padding: 14px 16px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    flex-wrap: wrap;
  }

  .billing-coupons-table-header-row {
    color: var(--app-text) !important;
  }

  .billing-coupons-code {
    font-weight: 800;
    letter-spacing: 0.05em;
    color: var(--app-text);
  }

  .billing-coupons-plan-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .billing-coupons-plan-tag {
    margin: 0;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
  }

  .billing-coupons-action-trigger {
    height: auto;
    padding: 0;
    line-height: 1;
  }

  .billing-coupons-action-icon {
    color: var(--app-text);
  }

  .billing-coupons-action-trigger:hover .billing-coupons-action-icon {
    color: #f45b68;
  }

  .billing-coupons-delete-text {
    font-size: 13px;
    color: var(--app-text);
    line-height: 1.5;
  }

  @media (max-width: 768px) {
  .billing-coupons-modal {
    .ant-modal-content {
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 24px 48px rgba(17, 24, 39, 0.12);
    }

    .ant-modal-header {
      padding: 22px 24px 18px;
      border-bottom: 1px solid var(--app-border);
      margin-bottom: 0;
      background: var(--app-surface);
    }

    .ant-modal-body {
      padding: 0;
      background: var(--app-surface);
      max-height: 70vh;
      overflow-y: scroll;
      overflow-x: hidden;
      scrollbar-gutter: stable;
      scrollbar-width: thin;
      scrollbar-color: #b8bfcc var(--app-surface-alt);
    }

    .ant-modal-body::-webkit-scrollbar {
      width: 10px;
    }

    .ant-modal-body::-webkit-scrollbar-track {
      background: var(--app-surface-alt);
      border-radius: 999px;
      margin: 8px 0;
    }

    .ant-modal-body::-webkit-scrollbar-thumb {
      background: #b8bfcc;
      border-radius: 999px;
      border: 2px solid var(--app-surface-alt);
      min-height: 40px;
    }

    .ant-modal-body::-webkit-scrollbar-thumb:hover {
      background: #9aa3b2;
    }

    [data-bs-theme="dark"] & .ant-modal-body {
      scrollbar-color: #4a516c #23263a;
    }

    [data-bs-theme="dark"] & .ant-modal-body::-webkit-scrollbar-track {
      background: #23263a;
    }

    [data-bs-theme="dark"] & .ant-modal-body::-webkit-scrollbar-thumb {
      background: #4a516c;
      border-color: #23263a;
    }

    [data-bs-theme="dark"] & .ant-modal-body::-webkit-scrollbar-thumb:hover {
      background: #5c6480;
    }

    .ant-modal-footer {
      padding: 16px 24px 20px;
      border-top: 1px solid var(--app-border);
      margin-top: 0;
      background: var(--app-surface);
    }
  }

  .billing-coupons-modal-title {
    font-size: 17px;
    font-weight: 800;
    color: var(--app-text);
    letter-spacing: -0.02em;
    line-height: 1.3;
  }

  .billing-coupons-form {
    padding: 20px 24px 8px;
  }

  .billing-coupons-form .ant-form-item {
    margin-bottom: 16px;
  }

  .billing-coupons-form .ant-form-item:last-child {
    margin-bottom: 0;
  }

  .billing-coupons-form .ant-form-item-label > label {
    color: var(--app-text) !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    height: auto;
  }

  .billing-coupons-form .ant-form-item-explain-error {
    font-size: 12px;
    margin-top: 4px;
  }

  .billing-coupons-form .ant-row {
    row-gap: 0;
  }

  .billing-coupons-input-icon {
    color: #f45b68;
    font-size: 14px;
  }

  .billing-coupons-type-toggle.ant-radio-group {
    display: flex;
    width: 100%;
  }

  .billing-coupons-type-toggle .ant-radio-button-wrapper {
    flex: 1;
    height: 42px;
    line-height: 40px;
    text-align: center;
    font-size: 13px;
    font-weight: 600;
    border-color: var(--app-border);
    background: var(--app-surface-alt);
    color: var(--app-text-muted);
  }

  .billing-coupons-type-toggle .ant-radio-button-wrapper-checked {
    background: rgba(244, 91, 104, 0.1) !important;
    border-color: rgba(244, 91, 104, 0.45) !important;
    color: #f45b68 !important;
  }

  .billing-coupons-form-input.ant-input,
  .billing-coupons-form-input.ant-input-affix-wrapper,
  .billing-coupons-form-input.ant-input-number,
  .billing-coupons-form-input.ant-input-number .ant-input-number-input {
    height: 42px !important;
    border-radius: 10px !important;
    background: var(--app-surface-alt) !important;
    border-color: var(--app-border) !important;
    color: var(--app-text) !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }

  .billing-coupons-form-input.ant-input-affix-wrapper {
    padding-top: 0;
    padding-bottom: 0;
  }

  .billing-coupons-form-input.ant-input:hover,
  .billing-coupons-form-input.ant-input-affix-wrapper:hover,
  .billing-coupons-form-input.ant-input-number:hover {
    border-color: rgba(244, 91, 104, 0.35) !important;
  }

  .billing-coupons-form-input.ant-input:focus,
  .billing-coupons-form-input.ant-input-affix-wrapper-focused,
  .billing-coupons-form-input.ant-input-number-focused {
    border-color: rgba(244, 91, 104, 0.55) !important;
    box-shadow: 0 0 0 3px rgba(244, 91, 104, 0.1) !important;
  }

  .billing-coupons-form-input.ant-input-number {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .billing-coupons-form-input .ant-input-number-group-addon,
  .billing-coupons-form-input .ant-input-suffix {
    color: var(--app-text-muted);
    font-size: 12px;
    font-weight: 600;
    background: transparent;
    border-color: var(--app-border);
  }

  .billing-coupons-form-input.ant-input::placeholder,
  .billing-coupons-form-input.ant-input-number-input::placeholder {
    color: var(--app-text-muted) !important;
    font-weight: 400 !important;
    opacity: 0.85;
  }

  .billing-coupons-form-textarea.ant-input {
    min-height: 72px !important;
    height: auto !important;
    border-radius: 10px !important;
    background: var(--app-surface-alt) !important;
    border-color: var(--app-border) !important;
    color: var(--app-text) !important;
    font-size: 13px !important;
    padding: 10px 12px !important;
  }

  .billing-coupons-form-datepicker.ant-picker {
    width: 100%;
    height: 42px !important;
    border-radius: 10px !important;
    background: var(--app-surface-alt) !important;
    border-color: var(--app-border) !important;
  }

  .billing-coupons-form-datepicker .ant-picker-input > input {
    color: var(--app-text) !important;
    font-size: 13px !important;
    font-weight: 500 !important;
  }

  .billing-coupons-plans-select.ant-select {
    width: 100%;
  }

  .billing-coupons-plans-select .ant-select-selector {
    min-height: 42px !important;
    border-radius: 10px !important;
    background: var(--app-surface-alt) !important;
    border-color: var(--app-border) !important;
    padding-top: 5px !important;
    padding-bottom: 5px !important;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }

  .billing-coupons-plans-select.ant-select:hover .ant-select-selector {
    border-color: rgba(244, 91, 104, 0.35) !important;
  }

  .billing-coupons-plans-select.ant-select-focused .ant-select-selector {
    border-color: rgba(244, 91, 104, 0.55) !important;
    box-shadow: 0 0 0 3px rgba(244, 91, 104, 0.1) !important;
  }

  .billing-coupons-plans-select .ant-select-selection-item,
  .billing-coupons-plans-select .ant-select-selection-placeholder,
  .billing-coupons-plans-select .ant-select-selection-search-input {
    color: var(--app-text) !important;
    font-size: 13px !important;
    font-weight: 500 !important;
  }

  .billing-coupons-plans-select .ant-select-selection-placeholder {
    color: var(--app-text-muted) !important;
    font-weight: 400 !important;
  }

  .billing-coupons-plans-select .ant-select-selection-item {
    border-radius: 999px !important;
    background: rgba(244, 91, 104, 0.1) !important;
    border: 1px solid rgba(244, 91, 104, 0.22) !important;
    color: #f45b68 !important;
    font-weight: 700 !important;
  }

  @media (max-width: 768px) {
    .billing-coupons-toolbar {
      justify-content: stretch;
    }

    .billing-coupons-toolbar .ant-btn {
      flex: 1;
    }
  }
`;

export const BillingCouponsStatsModalGlobalStyle = createGlobalStyle`
  .billing-coupons-stats-modal .ant-modal-body {
    padding: 0 !important;
    max-height: 75vh;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .billing-coupons-stats-modal__inner {
    padding: 20px 24px 8px;
  }

  .billing-coupons-stats-modal__hero {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    padding: 16px;
    margin-bottom: 18px;
    border-radius: 14px;
    border: 1px solid var(--app-border);
    background: linear-gradient(
      135deg,
      color-mix(in srgb, var(--app-surface-alt) 88%, #f45b68 12%) 0%,
      var(--app-surface-alt) 100%
    );
  }

  .billing-coupons-stats-modal__hero-icon {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(244, 91, 104, 0.12);
    color: #f45b68;
    font-size: 20px;
    flex-shrink: 0;
  }

  .billing-coupons-stats-modal__hero-body {
    min-width: 0;
    flex: 1;
  }

  .billing-coupons-stats-modal__code {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 999px;
    background: var(--app-surface);
    border: 1px solid rgba(244, 91, 104, 0.28);
    color: #f45b68;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  .billing-coupons-stats-modal__name {
    margin-top: 8px;
    font-size: 16px;
    font-weight: 800;
    color: var(--app-text);
    line-height: 1.35;
    letter-spacing: -0.01em;
  }

  .billing-coupons-stats-modal__grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
    margin-bottom: 18px;
  }

  .billing-coupons-stats-modal__card {
    padding: 14px 14px 12px;
    border-radius: 12px;
    border: 1px solid var(--app-border);
    background: var(--app-surface);
  }

  .billing-coupons-stats-modal__card-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 10px;
  }

  .billing-coupons-stats-modal__card-icon {
    width: 32px;
    height: 32px;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--app-surface-alt);
    color: var(--app-text-muted);
    font-size: 15px;
  }

  .billing-coupons-stats-modal__card-label {
    font-size: 12px;
    font-weight: 600;
    color: var(--app-text-muted);
    line-height: 1.3;
  }

  .billing-coupons-stats-modal__card-value {
    font-size: 24px;
    font-weight: 800;
    color: var(--app-text);
    line-height: 1.1;
    letter-spacing: -0.02em;
  }

  .billing-coupons-stats-modal__card-sub {
    margin-top: 4px;
    font-size: 11px;
    color: var(--app-text-muted);
    font-weight: 500;
  }

  .billing-coupons-stats-modal__progress {
    margin-bottom: 18px;
    padding: 14px 16px;
    border-radius: 12px;
    border: 1px solid var(--app-border);
    background: var(--app-surface-alt);
  }

  .billing-coupons-stats-modal__progress-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
    font-size: 12px;
    font-weight: 600;
    color: var(--app-text-muted);
  }

  .billing-coupons-stats-modal__progress-value {
    color: var(--app-text);
    font-weight: 700;
  }

  .billing-coupons-stats-modal__section {
    margin-top: 18px;
  }

  .billing-coupons-stats-modal__section-title {
    font-size: 13px;
    font-weight: 800;
    color: var(--app-text);
    margin-bottom: 10px;
    letter-spacing: -0.01em;
  }

  .billing-coupons-stats-modal__empty {
    margin-top: 4px;
    padding: 28px 16px;
    border-radius: 12px;
    border: 1px dashed var(--app-border);
    background: var(--app-surface-alt);
    text-align: center;
  }

  .billing-coupons-stats-modal__empty-icon {
    font-size: 28px;
    color: var(--app-text-muted);
    margin-bottom: 8px;
    opacity: 0.7;
  }

  .billing-coupons-stats-modal__empty-title {
    font-size: 14px;
    font-weight: 700;
    color: var(--app-text);
    margin-bottom: 4px;
  }

  .billing-coupons-stats-modal__empty-text {
    font-size: 12px;
    color: var(--app-text-muted);
    line-height: 1.5;
  }

  @media (max-width: 768px) {
    .billing-coupons-stats-modal__grid {
      grid-template-columns: 1fr;
    }
  }
`;
